import { render, staticRenderFns } from "./SettingStore.vue?vue&type=template&id=90bdc57e"
import script from "./SettingStore.vue?vue&type=script&lang=js"
export * from "./SettingStore.vue?vue&type=script&lang=js"
import style0 from "./SettingStore.vue?vue&type=style&index=0&id=90bdc57e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports